import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';

/**
 * Sub form with additional fields like email address and taxation id to extend the anonymous invoice address form.
 */
@Component({
  selector: 'ish-formly-address-extension-form',
  templateUrl: './formly-address-extension-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormlyModule],
})
export class FormlyAddressExtensionFormComponent implements OnInit {
  readonly form = input.required<FormGroup>();
  readonly businessCustomer = input<boolean>(undefined);
  readonly model = input<
    Partial<{
      email: string;
      taxationId: string;
    }>
  >({}); // model with data for the update mode.

  fields: FormlyFieldConfig[];

  ngOnInit() {
    this.fields = [
      {
        key: 'email',
        type: 'ish-email-field',
        props: {
          required: true,
          label: 'checkout.addresses.email.label',
          customDescription: {
            key: 'account.address.email.hint',
          },
          postWrappers: [{ wrapper: 'description', index: -1 }],
        },
      },
    ];
    if (this.businessCustomer()) {
      this.fields = [this.createTaxationIDField(), ...this.fields];
    }
  }

  private createTaxationIDField(): FormlyFieldConfig {
    return {
      type: '#taxationID',
    };
  }
}
